namespace GeniuzPOS.QRreport {
    export interface QDayDataRow {
        Id?: number;
        Day?: number;
        DayName?: string;
        DayNameEn?: string;
    }

    export namespace QDayDataRow {
        export const idProperty = 'Day';
        export const nameProperty = 'DayName';
        export const localTextPrefix = 'QRreport.QDayData';
        export const lookupKey = 'QRreport.QDayData';

        export function getLookup(): Q.Lookup<QDayDataRow> {
            return Q.getLookup<QDayDataRow>('QRreport.QDayData');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Day = "Day",
            DayName = "DayName",
            DayNameEn = "DayNameEn"
        }
    }
}
